import { HashRouter, Route, Routes, Navigate } from 'react-router-dom';

// Components
import { RequireAuth } from '.';
import { Login, AdminSpace, PostConfigComponent, PostList } from '../admin-space';
import { LandingPage, BlogDetail } from '../main-app';
// import { Calculator } from '../main-app/apps';
import { SalaryCalc } from '../main-app/apps';

// CSS
import '../app.css';

const AppRoutes = () => {
    return (
        <HashRouter>
            <Routes>
                {/* <Route path='calc' element={<Calculator />}/> */}
                <Route path='salaryclc' element={<SalaryCalc />}/>
                <Route element={<RequireAuth />}>
                    <Route path='/admin-space' element={<Navigate to='/admin-space/list-post' />} />
                    <Route element={<AdminSpace />}>
                        <Route path='admin-space/create-post' element={<PostConfigComponent />}/>
                        <Route path='admin-space/:uuid/edit' element={<PostConfigComponent />}/>
                        <Route path='admin-space/list-post' element={<PostList />}/>
                    </Route>
                </Route>
                <Route path='login' element={<Login />} />
                <Route path='blog/:uuid' element={<BlogDetail />} />
                <Route path='/' element={<LandingPage />} />
                <Route path='*' element={<Navigate to='/' />} />
            </Routes>
        </HashRouter>
    );
};

export default AppRoutes;
